<div class="header-bar">
  <div class="header-left">
    <div class="header-text">Device Info</div>

    <div class="divider"></div>
    <div class="dates">
      <div class="date start-date">
        <div class="text">Start</div>
        <button
          mat-button
          class="icon-btn"
          (click)="startDatePicker.openPicker()"
        >
          <svg-icon
            src="assets/svg/calendar.svg"
            [svgStyle]="{
              'width.px': '26.5',
              'height.px': '26.5'
            }"
            svgClass="grey"
          >
          </svg-icon>
        </button>
        <lhpe-datepicker
          #startDatePicker
          [hideToggle]="true"
          placeholder="mm/dd/yyyy"
          [formGroup]="filterForm"
          controlName="startDate"
        >
        </lhpe-datepicker>
      </div>
      <div class="date end-date">
        <div class="text">End</div>
        <button
          mat-button
          class="icon-btn"
          (click)="endDatePicker.openPicker()"
        >
          <svg-icon
            src="assets/svg/calendar.svg"
            [svgStyle]="{
              'width.px': '26.5',
              'height.px': '26.5'
            }"
            svgClass="grey"
          >
          </svg-icon>
        </button>
        <lhpe-datepicker
          #endDatePicker
          [hideToggle]="true"
          placeholder="mm/dd/yyyy"
          [formGroup]="filterForm"
          controlName="endDate"
        >
        </lhpe-datepicker>
      </div>
    </div>

    <div class="divider"></div>
    <div class="filter">
      <button mat-button class="icon-btn" [matMenuTriggerFor]="deviceMenu">
        <svg-icon src="assets/svg/filter.svg" svgClass="grey"></svg-icon>
      </button>
      <mat-menu
        class="mat-menu-elaphant vertical-menu device-menu"
        #deviceMenu="matMenu"
      >
        <mat-checkbox
          *ngFor="let device of devices"
          [checked]="device.selected"
          color="lightGreen"
          (change)="device.selected = !device.selected"
          (click)="$event.stopPropagation()"
        >
          {{ device.name }}
        </mat-checkbox>
      </mat-menu>
    </div>
  </div>
  <div class="header-center"></div>
  <div class="header-right"></div>
</div>
<div class="device-info">
  <ng-container *ngFor="let device of selectedDevices">
    <div class="device-container {{ device.class }}">
      <div class="container-header">
        <div class="icon">
          <svg-icon src="assets/svg/{{ device.icon }}.svg"> </svg-icon>
        </div>
      </div>
      <div class="container-body">
        <div class="options">
          <div class="option">
            <button mat-icon-button [matMenuTriggerFor]="pallateMenu">
              <svg-icon src="assets/svg/ellipsis.svg"></svg-icon>
            </button>
            <mat-menu
              class="mat-menu-elaphant vertical-menu"
              #pallateMenu="matMenu"
            >
              <button
                class="icon-btn-w-text"
                *ngIf="unselectedDevices.length"
                (click)="device.newContainerOpen = true"
                mat-menu-item
              >
                <svg-icon
                  src="assets/svg/plus-circle-white.svg"
                  svgClass="white"
                ></svg-icon>
                <span>Create new pallete</span>
              </button>
              <button
                class="icon-btn-w-text"
                *ngIf="unselectedDevices.length"
                (click)="device.swapContainerOpen = true"
                mat-menu-item
              >
                <svg-icon
                  src="assets/svg/reload.svg"
                  svgClass="white"
                ></svg-icon>
                <span>Swap pallete</span>
              </button>
              <button
                class="icon-btn-w-text"
                mat-menu-item
                (click)="closeDevice(device)"
              >
                <svg-icon
                  src="assets/svg/x-circle.21.5.svg"
                  [svgStyle]="{
                    'width.px': '21.5',
                    'height.px': '21.5'
                  }"
                  svgClass="white"
                ></svg-icon>
                <span>Close pallete</span>
              </button>
            </mat-menu>
          </div>
        </div>
        <div class="panel-rows">
          <div class="panel-row">
            <div class="panel range-panel">
              <div class="heading">Installs this range</div>
              <div class="value">{{ device.data.app_devices_range }}</div>
              <div class="graph-heading">Percentage of total installs</div>
              <div
                echarts
                [options]="device.installsOptions"
                class="pie-chart"
              ></div>
              <div
                id="addText"
                style="position: absolute; left: 0px; top: 0px"
              ></div>
            </div>
            <div class="panel range-panel">
              <div class="heading">Active this range</div>
              <div class="value">{{ device.data.active }}</div>
              <div class="graph-heading">Percentage of total active</div>
              <div
                echarts
                [options]="device.activeOptions"
                class="pie-chart"
              ></div>
              <div
                id="addText"
                style="position: absolute; left: 0px; top: 0px"
              ></div>
            </div>
          </div>
          <div class="panel-row">
            <div class="panel allowed-panel">
              <div class="heading">Notifications allowed</div>
              <div
                echarts
                [options]="device.notificationsAllowedOptions"
                class="pie-chart"
              ></div>
            </div>
            <div class="panel allowed-panel">
              <div class="heading">Location allowed</div>
              <div
                echarts
                [options]="device.locationAllowedOptions"
                class="pie-chart"
              ></div>
            </div>
          </div>
          <div class="panel-row">
            <div class="panel distribution-panel">
              <div class="heading">OS version distribution</div>
              <div class="content">
                <div
                  *ngFor="let version of device.data.os_versions"
                  class="version"
                >
                  <div class="percent">
                    {{
                      math.round(
                        (version.total / device.data.total_installs) * 100
                      )
                    }}%
                  </div>

                  <div class="number">{{ version.system_version }}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="panel-row">
            <div class="panel distribution-panel">
              <div class="heading">App version distribution</div>
              <div class="content">
                <div
                  *ngFor="let version of device.data.app_versions"
                  class="version"
                  class="version"
                >
                  <div class="percent">
                    {{
                      math.round(
                        (version.total / device.data.total_installs) * 100
                      )
                    }}%
                  </div>
                  <div class="number">
                    {{ version.app_version ? version.app_version : "-" }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      *ngIf="device.swapContainerOpen"
      class="container device-container swap-container"
    >
      <div class="container-header">
        <lhpe-select
          controlName="swapDevice"
          placeholder="Select swap device"
          [formGroup]="deviceForm!"
          [optionIsSelf]="true"
          displayValue="name"
          [options]="unselectedDevices"
          (change)="onSwapDeviceSelected(device)"
        >
        </lhpe-select>
        <div class="options">
          <button mat-icon-button [matMenuTriggerFor]="swapMenu">
            <svg-icon src="assets/svg/ellipsis.svg"></svg-icon>
          </button>
          <mat-menu class="mat-menu-elaphant vertical-menu" #swapMenu="matMenu">
            <button
              class="icon-btn-w-text"
              mat-menu-item
              (click)="device.swapContainerOpen = false"
            >
              <svg-icon
                src="assets/svg/x-circle.21.5.svg"
                [svgStyle]="{
                  'width.px': '21.5',
                  'height.px': '21.5'
                }"
                svgClass="white"
              ></svg-icon>
              <span>Cancel swap</span>
            </button>
          </mat-menu>
        </div>
      </div>
    </div>

    <div
      *ngIf="device.newContainerOpen"
      class="container device-container swap-container"
    >
      <div class="container-header">
        <lhpe-select
          controlName="newDevice"
          placeholder="Select new palette"
          [formGroup]="deviceForm!"
          [optionIsSelf]="true"
          displayValue="name"
          [options]="unselectedDevices"
          (change)="onNewDeviceSelected(device)"
        >
        </lhpe-select>
        <div class="options">
          <button mat-icon-button [matMenuTriggerFor]="newMenu">
            <svg-icon src="assets/svg/ellipsis.svg"></svg-icon>
          </button>
          <mat-menu class="mat-menu-elaphant vertical-menu" #newMenu="matMenu">
            <button
              class="icon-btn-w-text"
              mat-menu-item
              (click)="device.newContainerOpen = false"
            >
              <svg-icon
                src="assets/svg/x-circle.21.5.svg"
                [svgStyle]="{
                  'width.px': '21.5',
                  'height.px': '21.5'
                }"
                svgClass="white"
              ></svg-icon>
              <span>Cancel new palette</span>
            </button>
          </mat-menu>
        </div>
      </div>
    </div>
  </ng-container>
</div>
